import { Iconify } from '@btsis/ui';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Component, type ErrorInfo, type ReactNode } from 'react';

type Props = { children: ReactNode };
type State = { error: Error | null };

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Unhandled UI error', error, info.componentStack);
  }

  override render(): ReactNode {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <Box sx={{ minHeight: '100dvh', display: 'grid', placeItems: 'center', p: 2 }}>
        <Card sx={{ p: 6, maxWidth: 520 }}>
          <Stack spacing={2} alignItems="center" textAlign="center">
            <Iconify
              icon="solar:danger-triangle-bold-duotone"
              width={56}
              sx={{ color: 'error.main' }}
            />
            <Typography variant="h5">Beklenmeyen bir hata oluştu</Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Sayfa yüklenirken bir sorun çıktı. Sayfayı yenilemeyi deneyin; sorun sürerse sistem
              yöneticinize bildirin.
            </Typography>
            <Button variant="contained" onClick={() => window.location.reload()}>
              Sayfayı yenile
            </Button>
          </Stack>
        </Card>
      </Box>
    );
  }
}
